// ------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated from a template.
//
//     Manual changes to this file may cause unexpected behavior in your application.
//     Manual changes to this file will be overwritten if the code is regenerated.
// </auto-generated>
// ------------------------------------------------------------------------------

import { Dictionary } from '../../../shared/models/dictionary.model';
import { IBaseType } from '../../../shared/enums/ibase-type.enum';

export interface IVehicleEmissionCheckStatusType {
    id: number;
    value: string;
    displayValue: string;
    description: string;
    sortOrder: number;
    active: boolean;
}

export class VehicleEmissionCheckStatusType implements IVehicleEmissionCheckStatusType, IBaseType {
    public id: number;
    public value: string;
    public displayValue: string;
    public description: string;
    public sortOrder: number;
    public active: boolean;

    /**
		Returns Emissions Valid VehicleEmissionCheckStatusType
	**/
    get EmissionsValid(): IVehicleEmissionCheckStatusType {
        return this.FromId(5);
    }
    /**
		Returns Emissions Not Valid VehicleEmissionCheckStatusType
	**/
    get EmissionsNotValid(): IVehicleEmissionCheckStatusType {
        return this.FromId(10);
    }
    /**
		Returns Emissions Test Exempt VehicleEmissionCheckStatusType
	**/
    get EmissionsTestExempt(): IVehicleEmissionCheckStatusType {
        return this.FromId(15);
    }
    /**
		Returns Emissions Test Exempt 1st 5 Yr VehicleEmissionCheckStatusType
	**/
    get EmissionsTestExempt1st5Yr(): IVehicleEmissionCheckStatusType {
        return this.FromId(20);
    }

    private _dictionary: Dictionary = new Dictionary([]);

    constructor() {
        this._dictionary.add('5', { id: 5, value: 'EmissionsValid', displayValue: 'Emissions Valid', description: 'Emissions Valid', sortOrder: 999999, active: true });
        this._dictionary.add('10', { id: 10, value: 'EmissionsNotValid', displayValue: 'Emissions Not Valid', description: 'Emissions Not Valid', sortOrder: 999999, active: true });
        this._dictionary.add('15', { id: 15, value: 'EmissionsTestExempt', displayValue: 'Emissions Test Exempt', description: 'Emissions Test Exempt', sortOrder: 999999, active: true });
        this._dictionary.add('20', { id: 20, value: 'EmissionsTestExempt1st5Yr', displayValue: 'Emissions Test Exempt 1st 5 Yr', description: 'Emissions Text Exempt 1st 5 Years', sortOrder: 999999, active: true });
    }

    public ToString(): string {
        return this.displayValue == null ? null : this.displayValue.toString();
    }

    public FromId(id: number): IVehicleEmissionCheckStatusType {
        return this._dictionary[id];
    }

    public FromValue(value: string): IVehicleEmissionCheckStatusType {
        var match = this._dictionary.getValues().filter(d => d.value == value);

        if (match.length > 0) {
            return this._dictionary[match[0].id];
        } else {
            return undefined;
        }
    }

    public GetAll(): IVehicleEmissionCheckStatusType[] {
        return this._dictionary.getValues().sort(this.sort_by('sortOrder', false, null, this.sort_by('displayValue', false, null, null)));
    }

    public GetActive(): IVehicleEmissionCheckStatusType[] {
        return this.GetAll().filter(d => d.active);
    }

    public Sort(primaryField, secondaryField, reverse): IVehicleEmissionCheckStatusType[] {
        return this.GetAll().sort(this.sort_by(primaryField, reverse, null, secondaryField != null ? this.sort_by(secondaryField, reverse, null, null) : null));
    }

    private sort_by = (path, reverse, primer, then) => {
        var get = (obj, path) => {
                if (path) {
                    path = path.split('.');

                    for (var i = 0, len = path.length - 1; i < len; i++) {
                        obj = obj[path[i]];
                    }

                    return obj[path[len]];
                }
                return obj;
            },
            prime = (obj) => primer ? primer(get(obj, path)) : get(obj, path);

        return (a, b) => {
            var A = prime(a),
                B = prime(b);

            return (
                (A < B) ? -1 :
                    (A > B) ? 1 :
                        (typeof then === 'function') ? then(a, b) : 0
            ) * [1, -1][+!!reverse];
        };
    };
}
